export const EXCLUDE_ROUTE_LIST = ['notification', 'complementary-organization'];
